import { withCurrentParams } from 'actions/utils';
import { getSceneLayerIds } from 'actions/Broadcast/utils';
import { OVERLAY_LIVE_TOGGLE } from 'store/eventConstants';
import { BROADCAST_TOGGLE_OVERLAY_HIDDEN } from 'actions/Types';
import { updateSceneLayers } from '@shoflo/studio-redux/actions';

/**
 * Handles the creation of state related to the toggling of an overlay through the clicking of the eye-ball icon.
 *
 * @param - overlayId - the id of the overlay to toggle.
 */
export default overlayId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        overlays,
        meeting: { attendeeResponse }
      } = getState();
      const overlay = overlays.find(overlay => overlay._id === overlayId);
      const hidden = !overlay?.source.hidden;

      const payload = {
        source: {
          hidden
        }
      };

      const action = {
        type: BROADCAST_TOGGLE_OVERLAY_HIDDEN,
        request: async apiClient => {
          const broadcast =
            await apiClient.broadcast.updateOverlayAndGlobalSceneLayers(
              teamId,
              eventId,
              broadcastId,
              overlayId,
              payload
            );

          const updatedSceneLayerIds = getUpdatedSceneLayers(
            getSceneLayerIds(broadcast),
            hidden,
            overlayId
          );

          dispatch(updateSceneLayers(updatedSceneLayerIds, broadcast));
          // notify other directors
          socket.emit(OVERLAY_LIVE_TOGGLE, {
            overlayId,
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return overlayId;
        }
      };
      dispatch(action);
    }
  );
};

/**
 * This logic handles the positioning of the overlay. Overlays should
 * always come after SCENE_LAYER and many can be visible at a time.
 *
 * @param sceneLayerIds
 * @param hidden
 * @param overlayId
 * @returns {*}
 */
export const getUpdatedSceneLayers = (sceneLayerIds, hidden, overlayId) => {
  if (!hidden) {
    // the overlay has been made visible. add it
    sceneLayerIds.push(overlayId);
  } else {
    // the overlay has been made invisible. remove it
    sceneLayerIds = sceneLayerIds.filter(slId => !(slId === overlayId));
  }

  return sceneLayerIds;
};
